export default "__VITE_ASSET__Ceqoy85Z__"